/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from "react"
import { RegisterByGroupFiltered, RegisterByGroupFoother } from "./components"
import { BaseTable, Card, Loading, PermissionLink} from "components"
import { DeleteItem } from "pages/ManagementAssets/Register/components"
import moment from "moment"
import { convertNumber } from "utils"
import { IoSendSharp } from "react-icons/io5"
import { useRegisterByGroup } from "../../hooks"
import { PERMISION } from "security"
// import toast from "react-hot-toast"

export function RegisterByGroup() {
  // const api = useApi()
  const depreciationMthode = [{ value: 1, label: "Straight Line" }]
  const depreciationPeriod = [
    { value: 1, label: "Month" },
    { value: 2, label: "Year" }
  ]

  const [filteredData, setFilteredData] = useState({ group_id: "", usage: "" })
  const dataByGroup = useRegisterByGroup({
    group_id: filteredData.group_id,
    usage: filteredData.usage
  })

  const convertCurrency = (currency: number) => {
    if (currency) {
      return convertNumber(currency)?.intoCurrency
    }
    return "-"
  }
  const DataStatus = () => (
    <tr>
      <td colSpan={19} className="text-center">
        <Loading
          loading={dataByGroup?.isLoading}
          errorText={dataByGroup?.isLoading ? "" : "No data available"}
        />
      </td>
    </tr>
  )

  return (
    <section className="flex flex-col gap-2 mt-2">
      <RegisterByGroupFiltered
        filter={filteredData}
        setFilter={setFilteredData}
      />

      <Card>
        <Card.Body>
          <div className="overflow-x-scroll max-h-[calc(100vh-580px)]">
            <BaseTable className=" border-transparent">
              <thead className="sticky top-0 z-1 !bg-black !text-white">
                <tr className="uppercase ">
                  <th>N0</th>
                  <th>CODE</th>
                  <th>DESCRIPTION</th>
                  <th>GROUP</th>
                  <th>BRAND</th>
                  <th>SERIAL</th>
                  <th>VENDOR</th>
                  <th>DIVISI</th>
                  <th>DEPARTEMENT</th>
                  <th>USAGE</th>
                  <th>ACQUISITION DATE</th>
                  <th>DEPRECIATION DURATION</th>
                  <th>DEPRECIATION METHOD</th>
                  <th>DEPRECIATION PERIOD</th>
                  <th>ACQUISITION COST</th>
                  <th>ACUMULATION DEPRECIATION</th>
                  <th>NET BOOK VALUE</th>
                  <th>DEPRECIATION EXPENSES</th>
                  <th>ACTION</th>
                </tr>
              </thead>
              <tbody>
                {dataByGroup?.data.length < 1 || dataByGroup?.isLoading ? (
                  <DataStatus />
                ) : (
                  dataByGroup?.data.map((item, key) => (
                    <tr key={key}>
                      <td>{key + 1}</td>
                      <td>{item?.asset_code || "-"}</td>
                      <td>{item?.asset_name || "-"}</td>
                      <td>{item?.mr_group_name || "-"}</td>
                      <td>{item?.mr_brand_name || "-"}</td>
                      <td>{item?.serial_document || "-"}</td>
                      <td>{item?.vendor_name || "-"}</td>
                      <td>{item?.divisi_name || "-"}</td>
                      <td>{item?.department_name || "-"}</td>
                      <td>{item?.disposal ? "Disposal" : "Active"}</td>
                      <td>
                        {item?.acquisition_date
                          ? moment(item?.acquisition_date).format("DD/MM/YYYY")
                          : "-"}
                      </td>
                      <td>
                        {item?.depreciation_duration
                          ? `${parseFloat(item?.depreciation_duration)} Months`
                          : "-"}
                      </td>
                      <td>
                        {item?.depreciation_methode
                          ? depreciationMthode?.find(
                              (val) => val?.value === item?.depreciation_methode
                            )?.label
                          : "-"}
                      </td>
                      <td>
                        {item?.depreciation_period
                          ? depreciationPeriod?.find(
                              (val) => val?.value === item?.depreciation_period
                            )?.label
                          : "-"}
                      </td>
                      <td className="text-right">
                        {convertCurrency(Number(item?.acquisition_cost))}
                      </td>
                      <td className="text-right">
                        {convertCurrency(
                          Number(item?.depreciation_accumulation)
                        )}
                      </td>
                      <td className="text-right">
                        {convertCurrency(Number(item?.net_book))}
                      </td>
                      <td className="text-right">
                        {convertCurrency(Number(item?.depreciation_expences))}
                      </td>
                      <td>
                        <section className="text-lg flex items-center cursor-pointer">
                          <PermissionLink
                            permission={PERMISION.ASET_MANAGEMENT.REGISTER.BY_GROUP.UPDATE}
                            to={`/asset-management/transaction/profile-asset/${item?.asset_id}`}>
                            <button
                              className="pe-4 rounded-full"
                              title="Collapse">
                              <IoSendSharp size={15} />
                            </button>
                          </PermissionLink>

                          {item.disposal === false ? (
                            <DeleteItem
                              item={{
                                asset_id:Number(item.asset_id),
                                asset_code: item.asset_code,
                                asset_name: item.asset_name,
                              }}
                              onSuccess={dataByGroup.refetch}
                            />
                          ) : null}
                        </section>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </BaseTable>
          </div>

          <RegisterByGroupFoother data={dataByGroup?.data} />
        </Card.Body>
      </Card>
    </section>
  )
}
